import { CapoPlugin } from "/home/kwesterfeld/ybd/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];